import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { ArrowRight } from 'lucide-react'

interface Props {
  docUrl: string
  onChange: (url: string) => void
  onNext: () => void
}

const isValidUrl = (url: string) => {
  try {
    const parsed = new URL(url)
    return parsed.protocol === 'https:' || parsed.protocol === 'http:'
  } catch {
    return false
  }
}

export default function DocUrlStep({ docUrl, onChange, onNext }: Props) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Cole a URL da documentação da API da ferramenta que você deseja integrar. Seu agente vai usá-la como referência.
      </p>
      <div className="space-y-2">
        <Label htmlFor="doc-url">URL da documentação</Label>
        <Input
          id="doc-url"
          type="url"
          placeholder="https://docs.exemplo.com/api"
          value={docUrl}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      <div className="flex justify-end">
        <Button onClick={onNext} disabled={!isValidUrl(docUrl)}>
          Próximo <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
